import { PermissionsType } from 'src/api';

// These should match backend/src/modules/users/permissionsTypes.ts
export const SYSTEM_PERMISSIONS = {
  NAV_CASES: 'NAV_CASES',
  NAV_USERS: 'NAV_USERS',
  NAV_INSIGHTS: 'NAV_INSIGHTS',
  NAV_ADMIN: 'NAV_ADMIN',
  NAV_DISCLOSURES: 'NAV_DISCLOSURES',
  MANAGE_USERS: 'MANAGE_USERS',
  MANAGE_CASES: 'MANAGE_CASES',
  MANAGE_GROUPS: 'MANAGE_GROUPS',
  MANAGE_ADMIN: 'MANAGE_ADMIN',
  MANAGE_ROUTING: 'MANAGE_ROUTING',
  MANAGE_TAGS: 'MANAGE_TAGS',
  MANAGE_CUSTOM_FIELDS: 'MANAGE_CUSTOM_FIELDS',
  VIEW_INSIGHTS: 'VIEW_INSIGHTS',
  EDIT_ALL_CASES: 'EDIT_ALL_CASES',
  LIST_ALL_CASES: 'LIST_ALL_CASES',
  CREATE_NEW_REPORT: 'CREATE_NEW_REPORT',
  CREATE_EXISTING_REPORT: 'CREATE_EXISTING_REPORT',
  GRANT_SPECIAL_ROLES: 'GRANT_SPECIAL_ROLES',
  REVOKE_SPECIAL_ROLES: 'REVOKE_SPECIAL_ROLES',
  ADMINISTER_ALL_CASES: 'ADMINISTER_ALL_CASES',
  ASSIGN_SELF_OTHER_ROLES: 'ASSIGN_SELF_OTHER_ROLES',
  ASSIGNABLE_AS_CASE_LEAD: 'ASSIGNABLE_AS_CASE_LEAD',
  ASSIGNABLE_TO_CASE_TEAM: 'ASSIGNABLE_TO_CASE_TEAM',
  ASSIGNABLE_TO_DISCLOSURES_CASE_TEAM: 'ASSIGNABLE_TO_DISCLOSURES_CASE_TEAM',
  ASSIGNABLE_AS_DISCLOSURES_CASE_LEAD: 'ASSIGNABLE_AS_DISCLOSURES_CASE_LEAD',
  ADMINISTER_NON_OFFENDER_CASES: 'ADMINISTER_NON_OFFENDER_CASES',
};

const permissionsMap: Record<PermissionsType, string[]> = {
  super: [
    SYSTEM_PERMISSIONS.NAV_CASES,
    SYSTEM_PERMISSIONS.NAV_USERS,
    SYSTEM_PERMISSIONS.NAV_INSIGHTS,
    SYSTEM_PERMISSIONS.NAV_ADMIN,
    SYSTEM_PERMISSIONS.NAV_DISCLOSURES,
    SYSTEM_PERMISSIONS.MANAGE_GROUPS,
    SYSTEM_PERMISSIONS.MANAGE_USERS,
    SYSTEM_PERMISSIONS.VIEW_INSIGHTS,
    SYSTEM_PERMISSIONS.MANAGE_ADMIN,
    SYSTEM_PERMISSIONS.MANAGE_ROUTING,
    SYSTEM_PERMISSIONS.EDIT_ALL_CASES,
    SYSTEM_PERMISSIONS.LIST_ALL_CASES,
    SYSTEM_PERMISSIONS.CREATE_NEW_REPORT,
    SYSTEM_PERMISSIONS.CREATE_EXISTING_REPORT,
    SYSTEM_PERMISSIONS.GRANT_SPECIAL_ROLES,
    SYSTEM_PERMISSIONS.REVOKE_SPECIAL_ROLES,
    SYSTEM_PERMISSIONS.ADMINISTER_ALL_CASES,
    SYSTEM_PERMISSIONS.ASSIGN_SELF_OTHER_ROLES,
    SYSTEM_PERMISSIONS.MANAGE_TAGS,
    SYSTEM_PERMISSIONS.MANAGE_CUSTOM_FIELDS,
  ],
  admin: [
    SYSTEM_PERMISSIONS.NAV_USERS,
    SYSTEM_PERMISSIONS.NAV_INSIGHTS,
    SYSTEM_PERMISSIONS.NAV_ADMIN,
    SYSTEM_PERMISSIONS.MANAGE_GROUPS,
    SYSTEM_PERMISSIONS.MANAGE_USERS,
    SYSTEM_PERMISSIONS.VIEW_INSIGHTS,
    SYSTEM_PERMISSIONS.MANAGE_ADMIN,
    SYSTEM_PERMISSIONS.MANAGE_ROUTING,
    SYSTEM_PERMISSIONS.REVOKE_SPECIAL_ROLES,
    SYSTEM_PERMISSIONS.ADMINISTER_ALL_CASES,
    SYSTEM_PERMISSIONS.MANAGE_TAGS,
    SYSTEM_PERMISSIONS.MANAGE_CUSTOM_FIELDS,
  ],
  manager: [
    SYSTEM_PERMISSIONS.NAV_CASES,
    SYSTEM_PERMISSIONS.ASSIGNABLE_AS_CASE_LEAD,
    SYSTEM_PERMISSIONS.CREATE_NEW_REPORT,
    SYSTEM_PERMISSIONS.ASSIGNABLE_TO_CASE_TEAM,
  ],
  app: [],
  public: [],
  moderator: [
    SYSTEM_PERMISSIONS.NAV_CASES,
    SYSTEM_PERMISSIONS.NAV_INSIGHTS,
    SYSTEM_PERMISSIONS.VIEW_INSIGHTS,
    SYSTEM_PERMISSIONS.LIST_ALL_CASES,
    SYSTEM_PERMISSIONS.ADMINISTER_NON_OFFENDER_CASES,
    SYSTEM_PERMISSIONS.MANAGE_TAGS,
    SYSTEM_PERMISSIONS.CREATE_EXISTING_REPORT,
    SYSTEM_PERMISSIONS.MANAGE_CUSTOM_FIELDS,
  ],
  collaborator: [
    SYSTEM_PERMISSIONS.NAV_CASES,
    SYSTEM_PERMISSIONS.ASSIGNABLE_TO_CASE_TEAM,
  ],
  // Add other mappings as needed
};

export function permissionsToSystemPermissions(
  permissions: PermissionsType[],
): string[] {
  // Only include systemPermissions for currently present permissions
  const set = new Set<string>();
  permissions.forEach((perm) => {
    (permissionsMap[perm] || []).forEach((sysPerm) => set.add(sysPerm));
  });
  return Array.from(set);
}

export function roleToSystemPermissions(role: PermissionsType): string[] {
  return permissionsMap[role] || [];
}
